// extracted by mini-css-extract-plugin
export default {"wrapper":"ImageItem_wrapper__nLYBB","active":"ImageItem_active__2P4oK","img":"ImageItem_img__DZrGh","text":"ImageItem_text__LHbju"};